import React from 'react';
import { Text } from '@ui';
import { translate } from '@utils/i18n';
import './SyncErrorBannerStyles.scss';
import { formatAbsoluteTime } from '../utils/formatRelativeTime';
const NAMESPACE = 'features.settings.integrations.sync_error_banner';
/**
 * Red error banner shown when an integration category has a current error.
 * Matches the IP-13778 design: an info icon, a bold "Last error" title, the
 * error message, and a meta line pairing the absolute error time with a
 * "View details" link to the affected record (when subject metadata exists).
 */
export function SyncErrorBanner({ errorCategory }) {
    const { lastErrorMessage, lastErrorAt, subject } = errorCategory;
    const timestamp = lastErrorAt ? formatAbsoluteTime(lastErrorAt) : null;
    return (React.createElement("div", { className: "qmb-ui-sync-error-banner", role: "alert", "aria-live": "polite" },
        React.createElement("i", { className: "fa-light fa-circle-info sync-error-banner__icon", "aria-hidden": "true" }),
        React.createElement("div", { className: "sync-error-banner__content" },
            React.createElement(Text, { variant: "label", as: "strong", className: "sync-error-banner__title" }, translate('title', { namespace: NAMESPACE })),
            lastErrorMessage && (React.createElement(Text, { variant: "body", className: "sync-error-banner__message" }, lastErrorMessage)),
            (timestamp || subject) && (React.createElement("div", { className: "sync-error-banner__meta" },
                timestamp && (React.createElement(Text, { variant: "x-small", className: "sync-error-banner__timestamp" }, timestamp)),
                timestamp && subject && (React.createElement("span", { className: "sync-error-banner__meta-sep", "aria-hidden": "true" }, "\u00B7")),
                subject && (React.createElement(Text, { variant: "x-small", className: "sync-error-banner__details-link" },
                    React.createElement("a", { href: subject.url }, translate('view_details', { namespace: NAMESPACE })))))))));
}
